import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';

/**
 * Error Interceptor - Handles HTTP errors globally
 *
 * Specifically handles 401 Unauthorized errors by:
 * 1. Showing a session expired notification
 * 2. Logging out the user
 * 3. Redirecting to login page
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const notificationService = inject(NotificationService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Handle 401 Unauthorized errors (JWT expired or invalid)
      if (error.status === 401) {
        // Show session expired notification
        notificationService.showSessionExpired();

        // Logout the user (clears tokens and redirects to login)
        authService.logout();
      }

      // Re-throw the error so other error handlers can process it if needed
      return throwError(() => error);
    })
  );
};
